module.exports = __webpack_public_path__ + "prod/1.42.2/img/cma-cov.653e8a53.png";